export default class Hero {
    constructor() {
      this.classNames = {
        block: 'b-af-hero',
        slider: 'slick-slider',
        prevArrow: 'b-af-hero__nav-prev',
        nextArrow: 'b-af-hero__nav-next',
        loaderBar: 'b-af-hero__loader-bar',
        slickTrack: 'slick-track',
        slickSlide: 'slick-slide',
        wistiaSlide: 'slick-slide--wistia-background',
      }

      this.blocks = this.getHeroBlocks();

      if (this.blocks.length > 0) {
        this.init(this.blocks);
      }
    }

    init(blocks) {
      blocks.forEach(block => {
        const slider = block.querySelector(`.${this.classNames.slider}`);

        this.handleSlider(slider, block);
      });
    }

    handleSlider(slider, block) {
      const that = this;

      if (!slider) {
        return;
      }

      const autoPlay = slider.dataset.autoPlay;
      const timer = slider.dataset.timer;

      $(slider).slick({
        autoplay: Boolean(autoPlay),
        autoplaySpeed: timer * 1000,
        center: true,
        pauseOnHover: false,
        loop: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: block.querySelector(`.${this.classNames.prevArrow}`),
        nextArrow: block.querySelector(`.${this.classNames.nextArrow}`),
        adaptiveHeight: true,
      });

      this.flagWistiaSlides(slider);

      $(slider).on('beforeChange', function() {
        var els = block.querySelectorAll(`.${that.classNames.loaderBar}`);
        els.forEach(el => {
          that.resetLoaderAnimation(el);
        });
      });

      $(slider).on('afterChange', (_, slick, currentSlideIndex) => {
        // Slick resets infinite-wrap positioning after afterChange handlers finish.
        window.requestAnimationFrame(() => {
          $(window).trigger('scroll');
        });

        const lottieAnimation = this.getCurrentLottieBySlide(slick.$slides[currentSlideIndex]);

        if (!lottieAnimation) {
          return;
        }

        lottieAnimation.goToAndPlay(0);
      });
    }

    getHeroBlocks() {
        return Array.from(document.querySelectorAll(`.${this.classNames.block}`));
    }

    flagWistiaSlides(slider) {
      slider.querySelectorAll(`.${this.classNames.slickSlide}`).forEach(slide => {
        if (slide.querySelector('.c-background-video .c-video--source-wistia')) {
          slide.classList.add(this.classNames.wistiaSlide);
        }
      });
    }

    getCurrentLottieBySlide(slide) {
        const lottieNode = slide.querySelector('.c-new-lottie-animation');

        if (!lottieNode) {
            return null;
        }

        return window.lottieAnimations[lottieNode.dataset.id];
    }

    resetLoaderAnimation(el) {
        el.style.animation = 'none';
        el.offsetHeight; /* trigger reflow */
        el.style.animation = null;
    }
}



// WEBPACK FOOTER //
// ./scripts/blocks/hero.js